import type { PayPalNamespace } from '@paypal/paypal-js'
import type { Stripe } from '@stripe/stripe-js'
import { common } from './general'

let paypal: PayPalNamespace|undefined|null
let stripe: Stripe|undefined|null

export const usePaypal = async () => {
  if (paypal) {
    return paypal!
  }

  const { loadScript } = await import('@paypal/paypal-js')

  paypal = await loadScript({ clientId: common.paypal.clientId })

  return paypal!
}

export const useStripe = async () => {
  if (stripe) {
    return stripe!
  }

  const { loadStripe } = await import('@stripe/stripe-js')

  return stripe = await loadStripe(common.stripe.clientId)
}